import { AiFillStar } from "react-icons/ai"

function MobileCard({ image, name, rating, and, review, ram, display, camera, battery, warranty, price, assured, cuttoff, delivery, bank, off, star, processor }) {
    return (
        <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", borderTop: "1px solid #E0E0E0", padding: "20px" }}>
            <div style={{ width: "20%", margin: "auto" }}>
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <img style={{ height: "200px" }} src={image} alt={name} />
                </div>
            </div>
            <div style={{ width: "50%", margin: "auto", textAlign: "start" }}>
                <div style={{ fontSize: "20px", fontWeight: "500", marginBottom: "5px" }}>{name}</div>
                <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "10px" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "3px", backgroundColor: "#388e3c", color: "white", padding: "2px 6px", borderRadius: "3px", fontSize: "12px" }}>
                        <span>{star}</span>
                        <AiFillStar style={{ fontSize: "10px" }} />
                    </div>
                    <div style={{ color: "#878787", fontSize: "14px" }}>
                        <span>{rating} {and} {review}</span>
                    </div>
                </div>
                <div style={{ fontSize: "14px", color: "#212121", lineHeight: "1.5" }}>
                    <div style={{ marginBottom: "2px" }}>• {ram}</div>
                    <div style={{ marginBottom: "2px" }}>• {display}</div>
                    <div style={{ marginBottom: "2px" }}>• {camera}</div>
                    <div style={{ marginBottom: "2px" }}>• {processor}</div>
                    <div style={{ marginBottom: "2px" }}>• {battery}</div>
                    <div style={{ marginBottom: "2px" }}>• {warranty}</div>
                </div>
            </div>
            <div style={{ width: "20%", margin: "auto", textAlign: "start" }}>
                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    <div style={{ fontSize: "24px", fontWeight: "bold" }}>{price}</div>
                    <img style={{ width: "70px" }} src={assured} alt="assured" />
                </div>
                <div>
                    <div style={{ display: "flex", gap: "10px", alignItems: "center", marginTop: "5px" }}>
                        <div style={{ color: "#878787", textDecoration: "line-through" }}>{cuttoff}</div>
                        <div style={{ color: "#388e3c", fontWeight: "500" }}>{off}</div>
                    </div>
                    <div style={{ fontSize: "14px", marginTop: "5px" }}>{delivery}</div>
                    <div style={{ fontSize: "14px", color: "#212121" }}>{bank}</div>
                </div>
            </div>
        </div>
    )
}

export default MobileCard